import { SET_LOADING, SET_ORDERS } from "../Actions/OrderHistory.action";

const defaultState = {
  orderItems: {
    orders: [],
    pagination: {
      currentPageIndex: 1,
      displayedEntries: 0,
      edgeEntries: 0,
      intervalEnd: 0,
      intervalStart: 0,
      pageCount: 0,
      pageSize: 0,
      totalCount: 0,
    },
  },
  loading: true,
};

export const orderHistory = (state = defaultState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_ORDERS:
      return { ...payload, loading: false };
    case SET_LOADING:
      return { ...state, loading: payload.loading };
    default:
      return state;
  }
};
